import React from 'react';
import {IListColumnProps} from '../../src/@interfaces/components/List/IListColumnProps';
import {ListConfigNamedColumn} from '../../src/@types/components/List';
import {IListConfigRelationColumn} from '../../src/@interfaces/components/List/IListConfigRelationColumn';
import HasNewCommentIndicator from '../orders/HasNewCommentIndicator';
import {IOrderProductModel} from '../../src/@interfaces/models/Order/IOrderProductModel';

export default function OrderProductIndicatorsColumn(
        props: IListColumnProps<ListConfigNamedColumn<IListConfigRelationColumn>, IOrderProductModel>
) {
    return <div className="text-center">
        <HasNewCommentIndicator active={props.model.has_new_comments ?? false}/>
    </div>;
}
